module.exports = __webpack_public_path__ + "6f7e64bab24e16b056baf06a6ba3200b.svg";